import { useTrackPresence } from '@/hooks/usePresenceTracking';

/**
 * Invisible component that tracks user presence on the site
 * Add this to the app layout to track all visitors
 */
const PresenceTracker = () => {
  useTrackPresence();
  return null;
};

export default PresenceTracker;
